export default "__VITE_ASSET__dafaa7fc__"